import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';

/*
  Generated class for the MyEventsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MyEventsProvider {
  constructor(private http: HttpClient, private api: Api) {}

  getMyEvents(time?: string): Observable<any> {
    return this.api
      .get('events/loadMyEvents?pastCurrentUpcoming=' + time, {})
      .map(res => {
        return res;
      });
  }
  eventsList(): Observable<any> {
    return this.api
      .get('events/loadAllEvents?pastCurrentUpcoming=', {})
      .map(res => {
        return res;
      });
  }
  eventsLista(time?: string): Observable<any> {
    return this.api
      .get('events/loadAllEvents?pastCurrentUpcoming=' + time, {})
      .map(res => {
        return res;
      });
  }

  nearByEvents(
    country: string,
    pageNumber: number,
    pageSize: number
  ): Observable<any> {
    return this.api
      .get(
        `events/loadNearByEvents?published=TRUE&country=${country}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {}
      )
      .map(res => {
        return res;
      });
  }

  joinEvent(eventId): Observable<any> {
    return this.api.post('events/join', { eventUuid: eventId }).map(res => {
      return res;
    });
  }

  joinRequest(eventId): Observable<any> {
    return this.api.post('events/applyUser', { eventUuid: eventId })
  }

  getEvent(pin: string): Observable<any> {
    return this.api.get('events/loadByPid', { eventPin: pin }).map(res => {
      return res;
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/my-events/my-events.ts